import React, { useState, useEffect, useMemo } from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, Label, Input, Card, CardHeader, CardBody, Collapse, Spinner } from 'reactstrap';
import { flushSync } from "react-dom";
import { FaChevronRight, FaChevronLeft, FaChevronUp, FaChevronDown, FaSave } from 'react-icons/fa';
import './MahingaKai.css';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import ItemCommonTop from '../ItemPopup/ItemCommonTop';
import ItemCommonBottom from '../ItemPopup/ItemCommonBottom';
import ItemFooter from '../ItemPopup/ItemFooter';
import Action from '../Action/Action';
import MapView from '../Map/MapView';
import NonMapView from '../ItemsView/NonMapView';
import MaintenancePlan from '../MaintenancePlan/MaintenancePlan';
import Validate from '../Validate/Validate';
import ToggleSwitch from '../ThreeStateToggle/ToggleSwitch';
import { useNavigate, useLocation } from "react-router-dom";
import ReadMoreContent from '../Utilities/Ui/ReadMore';
import ItemTypeListView from '../ItemsView/ItemTypeListView';
import Documents from '../Uploads/Documents';
import ItemTypeListViewForMap from '../ItemsView/ItemTypeListViewForMap';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import useLocalStorage from "../Utilities/Hooks/useLocalStorage";
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const MahingaKai = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage, refreshToken }) => {
    const [roleName, setRoleName] = useState(localStorage.getItem("roleName"));
    const [farmRoleName, setFarmRoleName] = useLocalStorage('farmRoleName', null); const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    const { state } = useLocation(); const [toggleSwitch, setToggleSwitch] = useState('map & details');
    const [recreationalRiskPresent, setRecreationalRiskPresent] = useState(false); const [threatenedSpeciesRiskPresent, setThreatenedSpeciesRiskPresent] = useState(false);
    const navigate = useNavigate(); const [saving, setSaving] = useState(''); const [itemDeletesaving, setItemDeleteSaving] = useState('');
    const [isOpen, setIsOpen] = useState(true);
    const [isIconUp, setIsIconUp] = useState(true); const [imageUploadList, setImageUploadList] = useState([]);
    const toggle = () => {
        setIsOpen(!isOpen);
        setIsIconUp(!isIconUp);
    };
    const [formErrors, setFormErrors] = useState({});
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [loading, setLoading] = useState(true);
    const [mahingaKai, setMahingaKai] = useState({
        outlineList: [], itemList: [], itemTypes: [], uniqueItemTypes: [], Section: 'Community & Cultural Significance', SectionName: 'Sites and Species of Significance', SectionObj: {}, isWizardCompleted: false
        , catchmentOverview: {}, isMapOnly: true, isMapRisk: false
    });
    const [largeEnterpriseDetails, setLargeEnterpriseDetails] = useState({ isLargeEnterprise: false, LMUList: [], selectedLMUId: 0, isSmallEnterpriseShow: false })
    const [typeid, setTypeId] = useState(0);
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: false, isLMUPage: false, isCenterReq: false, isFarmCenterEditable: false, showLabel: true,
        isFarmOutlineEditable: false, zoomLevel: 15, polyType: '', itemsEditable: false, highlighteditemId: 0, isClear: false
    });
    const [itemPopup, setItemPopup] = useState({ showItemPopup: false, mapitem: [], farmId: farmId, id: 0, itemId: 0, markertype: '', canArchive: true });
    const [itemPopupHeader, setItemPopupHeader] = useState({ page: 'Community & Cultural Significance', lmu: '', LMUId: 0,  LMUIds: '', itemTypeName: '', itemTypeId: 0, Name: '', isDragged: false, Description: '', color: "#21b546", itemTypeDescription: '' });
    const [itemPopupMaptype, setItemPopupMaptype] = useState({ markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', });

    const [itemPopupBiodiversity, setItemPopupBiodiversity] = useState({ isVisible: false, isItemToBiodiversity: false, biodiversityComment: '' });
    const [itemPopupRisk, setItemPopupRisk] = useState({ isRisk: 'No', riskComment: '', isMitigated: false, mitigatedComment: '' });
    const [itemPopupAchievements, setItemPopupAchievements] = useState({ isAchievementsNotes: false, achievementsComment: '', isExpand: false });

    const [itemDeletePopup, setItemDeletePopup] = useState({ showItemDeletePopup: false, itemId: 0 });
    const [actionPopup, setActionPopup] = useState({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    const [maintenancePlanPopup, setMaintenancePlanPopup] = useState({ showMaintenancePlanPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });

    const [toggleItemTypeListState, setToggleItemTypeListState] = useState({ isOpen: false, isIconUp: false });
    const [toggleItemTypeState, setToggleItemTypeState] = useState({ itemTypeId: 0, isOpen: false, isIconUp: false });
    const [toggleItemState, setToggleItemState] = useState({ itemId: 0, isOpen: false, isIconUp: false });
    const [culturalValuesDescription, setCulturalValuesDescription] = useState('');
    const [tangataWhenua, setTangataWhenua] = useState('');
    const [significantSpecies, setSignificantSpecies] = useState('');
    const [significantSites, setSignificantSites] = useState('');
    const [threatenedSpecies, setThreatenedSpecies] = useState('');
    const [recreationalSites, setRecreationalSites] = useState('');
    const [savingCatchmentContext, setSavingCatchmentContext] = useState('');
    const [yesNoList, setYesNoList] = useState([]);
    const [popupAction, setPopupAction] = useState('');

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/mahingakai/GetMahingaKai/', {
                params: {
                    farmId: farmId
                }
            }
            );
            setMahingaKai({
                ...mahingaKai, outlineList: response.data.outlineList, itemList: response.data.itemList, itemTypes: response.data.itemTypes, uniqueItemTypes: response.data.uniqueItemTypes,
                SectionObj: response.data.section, isWizardCompleted: response.data.isFWFPCompleted, catchmentOverview: response.data.catchmentOverview
            });
            setCulturalValuesDescription(response.data.catchmentOverview.culturalValues);
            setTangataWhenua(response.data.catchmentOverview.tangataWhenua);
            setSignificantSpecies(response.data.catchmentOverview.significantSpecies);
            setSignificantSites(response.data.catchmentOverview.significantSites);
            setMapDetails({ ...mapDetails, zoomLevel: response.data.selectedZoomlevel, polyType: '' });
            setYesNoList(response.data.yesNoList);
            setRecreationalSites(response.data.catchmentOverview.recreationalSites);
            setThreatenedSpecies(response.data.catchmentOverview.threatenedSpecies);
            setRecreationalRiskPresent(response.data.recreationalRiskPresent);
            setThreatenedSpeciesRiskPresent(response.data.threatenedSpeciesRiskPresent);
            setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isLargeEnterprise: response.data.islargeEnterprise, LMUList: response.data.lmuItemList })
            setToggleItemTypeListState({ ...toggleItemTypeListState, isOpen: !response.data.isFWFPCompleted, isIconUp: !response.data.isFWFPCompleted })
            if (response.data.section != null) {
                var section = window.wizardDetails.filter(x => x.controllerName == response.data.section.routePath);
                if (section.length > 0 != null) {
                    setIsNextButtonVisible(section[0].isSectionCompleted);
                }
            }
            setLoading(false);

            if (state != null) {
                const { itemId, actionId, navigateFrom } = state;
                navigate(state.pathname, { replace: true });
                if (navigateFrom == "Actions") {
                    handleNavigateOpenActionPopup(itemId, actionId, response.data);
                }
                else {
                    editMapItemFromNavigation(itemId, response.data, navigateFrom)
                }
            }
        } catch (err) {
            console.log(err);
        }
    }

    const handleNavigateOpenActionPopup = (itemId, actionId, mahingaKai) => {
        const itemDetails = mahingaKai.itemList.filter(items => items.itemId == itemId)[0];
        setActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: itemDetails.itemTypeId, itemName: itemDetails.name, actionId: actionId });
    };

    function refreshPage() {
        setLoading(true);
        setMahingaKai({ ...mahingaKai, outlineList: [], itemList: [], itemTypes: [], uniqueItemTypes: [] });
        setFormErrors({});
        OnPageload();
    }

    function resetValues() {
        setItemPopup({ showItemPopup: false, mapitem: [], farmId: farmId, id: 0, itemId: 0, markertype: '', canArchive: true });
        setItemPopupHeader({ page: 'Community & Cultural Significance', lmu: '', LMUIds: '', itemTypeName: '', itemTypeId: 0, Name: '', isDragged: false, Description: '', color: "#21b546", itemTypeDescription: '' });
        setItemPopupMaptype({ markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', });
        setItemPopupBiodiversity({ isVisible: false, isItemToBiodiversity: false, biodiversityComment: '' });
        setItemPopupRisk({ isRisk: 'No', riskComment: '', isMitigated: false, mitigatedComment: '' });
        setItemPopupAchievements({ isAchievementsNotes: false, achievementsComment: '', isExpand: false });
        setItemDeletePopup({ showItemdeletePopup: false, itemId: 0 });
        setMapDetails({ ...mapDetails, isClear: true, polyType: '' });
        setFormErrors({});
    }

    /* Item select  and Clear*/
    const handleItemClick = (event, typeid, polyType) => {
        setTypeId(typeid);
        setMapDetails({ ...mapDetails, polyType: polyType, isClear: false });
    }

    function handleClearSelection() {
        setTypeId(0);
        setMapDetails({ ...mapDetails, polyType: '', isClear: true });
        window.location.reload(true);
    }

    /*ItemPopup value change Handle*/
    function handleItemPopupHeaderChange(event) {
        const { name, value, checked, type } = event.target;
        if (name == 'Name') {
            if (event.target.value.length > 60) {
                return false;
            }
        }
        setFormErrors({});
        setItemPopupHeader({ ...itemPopupHeader, [name]: type == 'checkbox' ? checked : value });
    }

    function handleItemPopupBiodiversity(event) {
        const { name, value, checked, type } = event.target;
        setItemPopupBiodiversity({ ...itemPopupBiodiversity, [name]: type == 'checkbox' ? checked : value });
    }

    function handleItemPopupRisk(event) {
        const { name, value, checked, type } = event.target;
        setItemPopupRisk({ ...itemPopupRisk, [name]: type == 'checkbox' ? checked : value });
    }

    function handleItemPopupAchievements(event) {
        const { name, value, checked, type } = event.target;
        setItemPopupAchievements({ ...itemPopupAchievements, [name]: type == 'checkbox' ? checked : value });
    }

    const handleLMUSelectChange = (event) => {
        const { name, value, checked, type } = event.target;
        setLargeEnterpriseDetails({ ...largeEnterpriseDetails, [name]: type == 'checkbox' ? checked : value });
    }

    /*Item Add and Submit*/
    function addMapItem(mapItem, maptype) {
        let path, area = 0.0, perimeter = 0.0, coordinates = '';
        var selectedItemType = mahingaKai.itemTypes.filter(item => item.id == typeid)[0];
        const ItemTypeName = selectedItemType.name;
        const isBiodiversityReq = selectedItemType.isBiodiversityReq == true ? true : false;
        let lmuId = largeEnterpriseDetails.selectedLMUId;

        /***********LMU Identification*************/
        if (maptype == 'marker') {
            largeEnterpriseDetails.LMUList.map((obj) => {
                const outlineCoordinates = obj.mapCoordinates.split(':');
                const outlinepositions = [];
                outlineCoordinates.filter(coor => coor != "").map((Coordinate) => {
                    const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                    outlinepositions.push(pos);
                })
                const outlinePolygon = new window.google.maps.Polygon({
                    paths: outlinepositions
                });
                const pos = { lat: mapItem.getPosition().lat(), lng: mapItem.getPosition().lng() }

                const inside = window.google.maps.geometry.poly.containsLocation(
                    pos,
                    outlinePolygon
                ) ? true : false;
                if (inside) {
                    lmuId = obj.id;
                }
            });
        }
        /***********LMU Identification*************/
        if (maptype == 'marker') {
            coordinates = mapItem.getPosition().lat().toFixed(6) + ", " + mapItem.getPosition().lng().toFixed(6);
        }
        else if (maptype == 'polygon') {
            path = mapItem.getPath();
            area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
            perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            var PolygonCoords = "";
            path.getArray().map((pointCo) => {

                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            coordinates = PolygonCoords;
        }
        else if (maptype == 'polyline') {
            path = mapItem.getPath();
            area = 0;
            perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            var PolygonCoords = "";
            path.getArray().map((pointCo) => {

                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            coordinates = PolygonCoords;
        }
        setItemPopup({ ...itemPopup, showItemPopup: true, mapitem: mapItem, farmId: farmId, id: 0, itemId: 0, markertype: maptype, canArchive: true });
        setItemPopupMaptype({ ...itemPopupMaptype, markertype: maptype, area: area, perimeter: perimeter, coordinates: coordinates });
        setItemPopupHeader({ ...itemPopupHeader, itemTypeName: ItemTypeName, itemTypeId: typeid, LMUId: lmuId, LMUIds: lmuId.toString(), Name: '', isDragged: false, Description: '', itemTypeDescription: selectedItemType.itemDescription });
        setItemPopupBiodiversity({ ...itemPopupBiodiversity, isVisible: isBiodiversityReq });
        setItemPopupAchievements({ ...itemPopupAchievements, isExpand: false });
        setPopupAction("AddNew");
    }

    const handleItemSubmit = async (event) => {
        setFormErrors({});
        setSaving(true);
        const errors = {};

        let form = {
            Id: itemPopup.id,
            MapMarkerType: itemPopup.markertype,
            FarmId: itemPopup.farmId,
            ItemId: itemPopup.itemId,
            Name: itemPopupHeader.Name,
            IsDragged: itemPopupHeader.isDragged,
            Description: itemPopupHeader.Description,
            Colour: itemPopupHeader.color,
            LMUId: itemPopupHeader.LMUId,
            ItemTypeId: itemPopupHeader.itemTypeId,
            Area: itemPopupMaptype.area,
            Length: itemPopupMaptype.perimeter,
            MapCoordinates: itemPopupMaptype.coordinates,
            IsAddsToBioDiversity: itemPopupBiodiversity.isItemToBiodiversity,
            BioDiversityComment: itemPopupBiodiversity.biodiversityComment,
            IsItemHaveAnyRisk: itemPopupRisk.isRisk,
            RiskDescription: itemPopupRisk.riskComment,
            IsMitigated: itemPopupRisk.isMitigated,
            MitigatedDescription: itemPopupRisk.mitigatedComment,
            IsAchievementOfNote: itemPopupAchievements.isAchievementsNotes,
            AchievementOfNoteComments: itemPopupAchievements.achievementsComment,
            userId: userId,
            LMUIds: itemPopupHeader.LMUIds, ImageUploadList: []
        }
        if (itemPopupHeader.LMUIds == null || itemPopupHeader.LMUIds == '' || itemPopupHeader.LMUIds == undefined || itemPopupHeader.LMUIds == '0') {
            errors.luid = "This is mandatory!";
        }
        setFormErrors(errors);
        for (var i = 0; i < imageUploadList.length; i++) {
            var obj = {};
            obj.Id = imageUploadList[i].id;
            obj.ImageDetail = imageUploadList[i].imageDetail;
            obj.ImageName = imageUploadList[i].imageName;
            obj.ImagePhysicalName = imageUploadList[i].imagePhysicalName;
            obj.ImagePath = imageUploadList[i].imagePath;
            form.ImageUploadList.push(obj);
        }
        if (!Validate(form) && Object.keys(errors).length == 0) {
            try {
                const response = await apiPost(
                    '/api/mahingakai/UpdateMahingaKai/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    });
                if (response.data != null) {
                    await refreshItemDetails();
                    setSaving(false);
                    toast.success("Item details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                    handleItemPopupClose();

                }
            } catch (error) {
                console.error('Error:', error);
            }
        }
        else {
            setSaving(false);
        }
        refreshToken();
    }

    const refreshItemDetails = async () => {
        const response = await apiGet(
            '/api/mahingakai/GetMahingaKai/', {
            params: {
                farmId: farmId
            }
        }
        );
        setMahingaKai({
            ...mahingaKai, itemList: response.data.itemList
        });
    }
    function handleItemPopupClose() {
        resetValues();
        if (popupAction == "AddNew") {
            setTimeout(() => {
                setPopupAction("");
                const scrollableDiv = document.getElementById("bodyid");

                if (scrollableDiv) {
                    scrollableDiv.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top
                }
            }, 400);
        }
    }

    /*Item Edit and Submit*/
    function editMapItem(mapItem, itemId, isDragged) {
        const itemDetails = mahingaKai.itemList.filter(items => items.itemId == itemId)[0];
        const ItemTypeName = mahingaKai.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].name;
        const ItemDescription = mahingaKai.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].itemDescription;
        let coordinates = itemDetails.mapCoordinates;
        if (isDragged) {
            coordinates = mapItem.latLng.lat().toFixed(6) + ", " + mapItem.latLng.lng().toFixed(6);
        }
        const isBiodiversityReq = true;
        if (itemDetails != null) {
            setItemPopup({ ...itemPopup, showItemPopup: true, mapitem: mapItem, farmId: farmId, id: itemDetails.id, itemId: itemDetails.itemId, markertype: itemDetails.mapMarkerType, canArchive: itemDetails.canArchive });
            setItemPopupMaptype({ ...itemPopupMaptype, markertype: itemDetails.mapMarkerType, area: itemDetails.area, perimeter: itemDetails.length, coordinates: coordinates });
            setItemPopupHeader({
                ...itemPopupHeader, itemTypeName: ItemTypeName, itemTypeId: itemDetails.itemTypeId, Name: itemDetails.name, LMUId: itemDetails.lmuId == null ? 0 : itemDetails.lmuId, LMUIds :itemDetails.lmuIds == null ? '' : itemDetails.lmuIds,
                isDragged: isDragged, Description: itemDetails.description, color: itemDetails.colour, isEdited: itemDetails.isEdited, itemTypeDescription: ItemDescription
            });
            setItemPopupBiodiversity({ ...itemPopupBiodiversity, isVisible: isBiodiversityReq, isItemToBiodiversity: itemDetails.isAddsToBioDiversity, biodiversityComment: itemDetails.bioDiversityComment });
            setItemPopupRisk({ isRisk: itemDetails.isItemHaveAnyRisk, riskComment: itemDetails.riskDescription, isMitigated: itemDetails.isMitigated, mitigatedComment: itemDetails.mitigatedDescription });
            setItemPopupAchievements({ ...itemPopupAchievements, isAchievementsNotes: itemDetails.isAchievementOfNote, achievementsComment: itemDetails.achievementOfNoteComments, isExpand: false });
        }
    }

    const editMapItemFromNavigation = (itemId, mahingaKai, navigateFrom) => {
        const itemDetails = mahingaKai.itemList.filter(items => items.itemId == itemId)[0];
        const ItemTypeName = mahingaKai.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].name;
        const ItemDescription = mahingaKai.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].itemDescription;
        let coordinates = itemDetails.mapCoordinates;
        const isBiodiversityReq = true;
        if (itemDetails != null) {
            setItemPopup({ ...itemPopup, showItemPopup: true, mapitem: [], farmId: farmId, id: itemDetails.id, itemId: itemDetails.itemId, markertype: itemDetails.mapMarkerType, canArchive: itemDetails.canArchive });
            setItemPopupMaptype({ ...itemPopupMaptype, markertype: itemDetails.mapMarkerType, area: itemDetails.area, perimeter: itemDetails.length, coordinates: coordinates });
            setItemPopupHeader({
                ...itemPopupHeader, itemTypeName: ItemTypeName, itemTypeId: itemDetails.itemTypeId, Name: itemDetails.name, LMUId: itemDetails.lmuId == null ? 0 : itemDetails.lmuId, LMUIds: itemDetails.lmuIds == null ? '' : itemDetails.lmuIds,
                Description: itemDetails.description, color: itemDetails.colour, isEdited: itemDetails.isEdited, itemTypeDescription: ItemDescription
            });
            setItemPopupBiodiversity({ ...itemPopupBiodiversity, isVisible: isBiodiversityReq, isItemToBiodiversity: itemDetails.isAddsToBioDiversity, biodiversityComment: itemDetails.bioDiversityComment });
            setItemPopupRisk({ isRisk: itemDetails.isItemHaveAnyRisk, riskComment: itemDetails.riskDescription, isMitigated: itemDetails.isMitigated, mitigatedComment: itemDetails.mitigatedDescription });
            let isExpand = false;
            if (navigateFrom == "Achievements")
                isExpand = true
            setItemPopupAchievements({ ...itemPopupAchievements, isAchievementsNotes: itemDetails.isAchievementOfNote, achievementsComment: itemDetails.achievementOfNoteComments, isExpand: isExpand });
        }
    }

    function handleItemEditPopup(itemId) {
        editMapItem([], itemId, false)
    }

    /*Item Delete*/
    function handleItemDeletePopup(itemId) {
        setItemDeletePopup({ showItemDeletePopup: true, itemId: itemId });
    }

    function handleItemDeletePopupClose() {
        setItemDeletePopup({ showItemDeletePopup: false, itemId: 0 });
    }

    const deleteItem = async (event) => {
        setItemDeleteSaving(true);
        const itemid = itemDeletePopup.itemId;
        try {
            const response = await apiGet(
                '/api/mahingakai/DeleteItem/', {
                params: {
                    itemId: itemid, userId: userId
                }
            }
            );
            if (response.data != null) {
                await refreshItemDetails();
                setItemDeleteSaving(false);
                handleItemDeletePopupClose();
                handleItemPopupClose();
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    /*Item- Action Popup handle*/
    function handleOpenActionPopup(itemId, actionId) {
        const itemDetails = mahingaKai.itemList.filter(items => items.itemId == itemId)[0];
        setActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: itemDetails.itemTypeId, itemName: itemDetails.name, actionId: actionId });
    };

    function handleActionClose() {
        setActionPopup({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    /*Item- MaintenancePlan Popup handle*/
    function handleOpenMaintenancePlanPopup(itemId) {
        const itemDetails = mahingaKai.itemList.filter(items => items.itemId == itemId)[0];
        setMaintenancePlanPopup({ ...maintenancePlanPopup, showMaintenancePlanPopup: true, itemId: itemId, itemName: itemDetails.name, itemTypeId: itemDetails.itemTypeId, actionId: 0 });
    }

    function handleMaintenancePlanClose() {
        setMaintenancePlanPopup({ ...maintenancePlanPopup, showMaintenancePlanPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    /*handle Toggle for nonMap View*/
    const handleItemTypeListTogole = (isOpen, isIconUp) => {
        setToggleItemTypeListState({ ...toggleItemTypeListState, isOpen: isOpen, isIconUp: isIconUp })
    }

    const handleItemTypeTogole = (itemTypeId, isOpen, isIconUp,) => {
        setToggleItemTypeState({ ...toggleItemTypeState, itemTypeId: itemTypeId, isOpen: isOpen, isIconUp: isIconUp })
    }

    const handleItemTogole = (itemId, isOpen, isIconUp) => {
        setToggleItemState({ ...toggleItemState, itemId: itemId, isOpen: isOpen, isIconUp: isIconUp })
    }

    /*handle Item highlight*/
    const handleItemHighlight = (itemId) => {
        setMapDetails({ ...mapDetails, highlighteditemId: itemId })
    }

    /*Avoid unwanted page refresh*/
    const mapView = useMemo(() => {
        return (
            <MapView width={toggleSwitch == 'map' ? '80vw' : '50vw'}
                height={toggleSwitch == 'map' ? '80vw' : '50vw'}
                itemModel={mahingaKai}
                mapDetails={mapDetails}
                addMapItem={addMapItem}
                largeEnterpriseDetails={largeEnterpriseDetails}
                editMapItem={editMapItem} >
            </MapView>
        )
    }, [mahingaKai, mapDetails, largeEnterpriseDetails, toggleSwitch])

    const itemTypeListView = useMemo(() => {

        return (
            <ItemTypeListViewForMap isWizardCompleted={mahingaKai.isWizardCompleted} Section={mahingaKai.Section}
                itemTypesList={mahingaKai.itemTypes}
                toggleItemTypeListState={toggleItemTypeListState}
                handleClearSelection={handleClearSelection}
                handleItemClick={handleItemClick}
                handleItemTypeListTogole={handleItemTypeListTogole}
                itemModel={mahingaKai}
            >
            </ItemTypeListViewForMap>
        )
    }, [mahingaKai, largeEnterpriseDetails, mahingaKai.SectionObj, toggleItemTypeListState, toggleItemTypeState, toggleItemState, mahingaKai.outlineCenter])

    const toggleSwitchChange = (e) => {
        setToggleSwitch(e)
        if (e == 'map') {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'none';
            document.getElementById('itemTypeListView').style.height = '70vh';
        }
        else if (e == 'details') {
            document.getElementById('mapView').style.display = 'none';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
        else {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
    }
    const [savingNext, setSavingNext] = useState(false); const [savingBack, setSavingBack] = useState(false);
    const [savingMahingaKai, setSavingMahingaKai] = useState(false);
    const handleMahingaKaiDetailSave = async (e, from, section, method) => {
        e.preventDefault();
        if (from == '') {
            setSavingMahingaKai(true);
        }
        else if (from == 'Next') {
            setSavingNext(true);
        }
        else if (from == 'Back') {
            setSavingBack(true);
        }
        var success = await handleCatchmentContextSave(e);
        if (success) {
            toast.success("Cultural & Community Significance Details Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
        }
        if (from == '') {
            setSavingMahingaKai(false);
        }
        else if (from == 'Next') {
            setSavingNext(false);
            method(section);
        }
        else if (from == 'Back') {
            setSavingBack(false);
            method(section);
        }
    }
    const handleCatchmentContextSave = async (e) => {
        e.preventDefault();
        var errorFound = false;
        setFormErrors({});
        const errors = {};
        if (threatenedSpecies == null || threatenedSpecies == '') {
            errors.threatenedSpecies = "This is mandatory!";
            errorFound = true;
        }
        else {
            errors.threatenedSpecies = "";
        }
        if (recreationalSites == null || recreationalSites == '') {
            errors.recreationalSites = "This is mandatory!";
            errorFound = true;
        }
        else {
            errors.recreationalSites = "";
        }
        setFormErrors(errors);
        if (!errorFound) {
            let form = {
                CulturalValuesDescription: culturalValuesDescription,
                FarmId: farmId,
                UserId: userId,
                TangataWhenua: tangataWhenua,
                SignificantSites: null,
                SignificantSpecies: null,
                IwiHapuRunanga: null,
                ThreatenedSpecies: threatenedSpecies == '' ? 'No' : threatenedSpecies,
                RecreationalSites: recreationalSites == '' ? 'No' : recreationalSites,
            }

            try {
                const response = await apiPost(
                    '/api/catchmentContext/SaveCatchmentData/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    });

            } catch (err) {
                setTimeout(() => {
                    setSavingCatchmentContext(false);
                }, 1000)

                if (!err?.response) {
                    toast.error("No server response!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                } else if (err.response?.status === 400) {
                    toast.error("Saving Cultural & Community Significance Details Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                } else {
                    toast.error("Saving Cultural & Community Significance Details Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                }
            }
            return true;
        }
        else {
            return false;
        }
    }

    const nonMapView = useMemo(() => {
        return (
            <NonMapView itemModel={mahingaKai}
                toggleItemTypeListState={toggleItemTypeListState}
                toggleItemTypeState={toggleItemTypeState}
                toggleItemState={toggleItemState}
                handleClearSelection={handleClearSelection}
                handleItemClick={handleItemClick}
                handleItemEditPopup={handleItemEditPopup}
                handleItemDeletePopup={handleItemDeletePopup}
                handleOpenActionPopup={handleOpenActionPopup}
                sectionObj={mahingaKai.SectionObj}
                largeEnterpriseDetails={largeEnterpriseDetails}
                handleLMUSelectChange={handleLMUSelectChange}
                handleItemTypeListTogole={handleItemTypeListTogole}
                handleItemTypeTogole={handleItemTypeTogole}
                handleItemTogole={handleItemTogole}
                handleItemHighlight={handleItemHighlight}
            ></NonMapView>
        )
    }, [mahingaKai, largeEnterpriseDetails, mahingaKai.SectionObj, toggleItemTypeListState, toggleItemTypeState, toggleItemState])

    const handleWizardChangedMahingakai = async (section) => {
        let form = {
            CulturalValuesDescription: culturalValuesDescription,
            FarmId: farmId,
            UserId: userId,
            TangataWhenua: tangataWhenua,
            SignificantSites: null,
            SignificantSpecies: null,
            IwiHapuRunanga: null,
            ThreatenedSpecies: threatenedSpecies == '' ? 'No' : threatenedSpecies,
            RecreationalSites: recreationalSites == '' ? 'No' : recreationalSites,
        }
        try {
            const response = await apiPost(
                '/api/catchmentContext/SaveCatchmentData/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response.status == 200) {
                handleWizardChanged(section);
            }
        } catch (err) {
            handleWizardChanged(section);
            if (!err?.response) {
                toast.error("No server response!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else if (err.response?.status === 400) {
                toast.error("Saving Catchment Details Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("Saving Catchment Details Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }

    }
    const handleThreatenedSpeciesValueChange = (event) => {
        if (threatenedSpeciesRiskPresent) {
            toast.error("Sorry, can't change this now as the risk has been created and at least one action raised against it.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
        else {
            const { name, value, checked, type } = event.target;
            setThreatenedSpecies(value);
        }
    }
    const handleRecreationalSitesValueChange = (event) => {
        if (recreationalRiskPresent) {
            toast.error("Sorry, can't change this now as the risk has been created and at least one action raised against it.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
        else {
            const { name, value, checked, type } = event.target;
            setRecreationalSites(value);
        }
    }

    const handleLMUChange = (event) => {
        var lus = '';
        let luArr = [];
        if (typeof event === 'object' && event.constructor === Object) {
            lus = event.value.toString();
        }
        else {
            event.forEach(lmu => {
                luArr.push(lmu.value);
            })
            lus = luArr.join(",");
        }

        setItemPopupHeader({ ...itemPopupHeader, LMUIds: lus });
    }

    const handleEditItemClick = (e) => {
        if (e.target.checked) {
            toast.error(
                (t) => (
                    <div>
                        <span>ALERT: when editing a shape remember to click inside the shape when finished, or when editing a line double click on the line, to save any changes.</span>
                        <button className="toast-close-button"
                            onClick={() => toast.dismiss(t.id)}
                        >
                            OK
                        </button>
                    </div>
                ),
                {
                    duration: Infinity, style: { border: '1px solid #f76054', padding: '16*/px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', }
                }
            );
        }
        setMapDetails({ ...mapDetails, isFarmCenterEditable: !mapDetails.itemsEditable, isFarmOutlineEditable: !mapDetails.itemsEditable, itemsEditable: !mapDetails.itemsEditable })
    }

    const CustomToastWithLink = () => (
        <div>
            <p>Answer the two Yes/No questions and complete the form. The system will automatically decide, based on your answers if there is any risk that needs to be mitigated when you reach that stage of the plan build.</p>
        </div>
    );
    const customId = "custom-id-yes";
    const showToastMessage = (e) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">Cultural and Community Significance</h3></Col>
                {mahingaKai.isWizardCompleted != true && !loading &&
                    <>
                        <Col>
                        {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                            <>
                            {savingNext ?
                                <Button className="float-end btn-next-page" onClick={(e) => handleMahingaKaiDetailSave(e, 'Next', mahingaKai.Section, handleWizardChanged)}
                                    disabled
                                >
                                    <Row>
                                        <Col sm="8">
                                            <span>
                                                {' '}Processing
                                            </span>
                                        </Col>
                                        <Col sm="4">
                                            <Spinner size="sm">
                                                Processing...
                                            </Spinner>
                                        </Col>
                                    </Row>
                                </Button>
                                :
                                <Button className="float-end btn-next-page" onClick={(e) => handleMahingaKaiDetailSave(e, 'Next', mahingaKai.Section, handleWizardChanged)} >
                                    Next <FaChevronRight />
                                </Button>
                            }
                            {savingMahingaKai ?
                                <Button style={{ float: "right" }} onClick={(e) => handleMahingaKaiDetailSave(e, '','', null)}
                                    disabled
                                >
                                    <Row>
                                        <Col sm="8">
                                            <span>
                                                {' '}Saving
                                            </span>
                                        </Col>
                                        <Col sm="4">
                                            <Spinner size="sm">
                                                Saving...
                                            </Spinner>
                                        </Col>
                                    </Row>
                                </Button>
                                :
                                <Button className="float-end btn-next-page" onClick={(e) => handleMahingaKaiDetailSave(e, '', '', null)} >
                                    Save 
                                </Button>
                            }
                            {savingBack ?
                                <Button className="float-end btn-next-page" onClick={(e) => handleMahingaKaiDetailSave(e, 'Back', mahingaKai.Section, handleWizardChangedBack)}
                                    disabled
                                >
                                    <Row>
                                        <Col sm="8">
                                            <span>
                                                {' '}Processing
                                            </span>
                                        </Col>
                                        <Col sm="4">
                                            <Spinner size="sm">
                                                Processing...
                                            </Spinner>
                                        </Col>
                                    </Row>
                                </Button>
                                :
                                <Button className="float-end btn-next-page" onClick={(e) => handleMahingaKaiDetailSave(e, 'Back', mahingaKai.Section, handleWizardChangedBack)} >
                                    Back <FaChevronLeft />
                                </Button>
                            }
                            
                            </>
                        }
                        {roleName != 'SWNZ Admin' && farmRoleName != 'SWNZ Admin' && farmRoleName != 'Manager' && isNextButtonVisible &&
                            <>
                            <Button className="float-end btn-next-page" onClick={(section) => handleMoveToNextPage(mahingaKai.Section)}>Next <FaChevronRight /> </Button>
                            <Button className="float-end btn-next-page" onClick={(section) => handleWizardChangedBack(mahingaKai.Section)}>Back <FaChevronLeft /> </Button>
                            </>
                        }
                    </Col>
                    </>
                }
            </Row>
            <br/>
            {loading ? <SpinnerContainer /> :
                <div>
                    <Row style={{ marginTop: '10px' }}>
                        <Col id='mapView'>
                            <Row className="map-layer">
                                <Col>
                                    <Row>
                                        <Col sm="3"> {toggleSwitch == 'map & details' &&
                                            <Button size="sm" id="btnShowFullmap" style={{backgroundColor:"#41533d"}} className="btn" onClick={(e) => toggleSwitchChange('map')}>Full Map&nbsp;&nbsp;
                                                <img src="/images/button-details_expand.png"  className="card_icon" ></img>
                                            </Button>
                                        }
                                            {toggleSwitch == 'map' &&
                                                <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#41533d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Map&nbsp;&nbsp;
                                                    <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                                </Button>
                                            }
                                        </Col>
                                        <Col sm="1"></Col>
                                        <Col sm="8">
                                            <div className="map-item-edit-div">
                                                <Label className="map-checkbox-label">Show LU layer</Label>
                                                <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={largeEnterpriseDetails.isSmallEnterpriseShow} onChange={(e) => setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isSmallEnterpriseShow: !largeEnterpriseDetails.isSmallEnterpriseShow })} name="isSmallEnterpriseShow" id="isSmallEnterpriseShow" />&nbsp;&nbsp;
                                                <Label className="map-checkbox-label">Edit Item</Label>
                                                <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.itemsEditable} onChange={(e) => handleEditItemClick(e)} name="isItemEdit" id="isItemEdit" />&nbsp;&nbsp;
                                                <Label className="map-checkbox-label">Show Label</Label>
                                                <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.showLabel} onChange={(e) => setMapDetails({ ...mapDetails, showLabel: !mapDetails.showLabel })} name="showLabel" id="showLabel" />&nbsp;&nbsp;
                                            </div>
                                        </Col>
                                    </Row>
                                    {mapView}
                                </Col>
                            </Row>
                        </Col>
                        <Col id="itemTypeListView" style={{ display: toggleSwitch == 'map' ? 'block' : 'none', height: "70vh", overflowY: "scroll", width: "20vw" }}>
                            <br />
                            {itemTypeListView}
                            <br />
                        </Col>
                        <Col id='nonMapView' style={{ width: "50vw", display: toggleSwitch == 'map' ? 'none' : 'block', marginTop: "-25px" }}>
                            <>
                                <Row>
                                    <Col> {toggleSwitch == 'map & details' &&
                                        <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#41533d" }} className="btn btnExpandContract" onClick={(e) => toggleSwitchChange('details')}>Full Details&nbsp;&nbsp;
                                            <img src="/images/button-details_expand.png" style={{}} className="card_icon" ></img>
                                        </Button>
                                    }
                                        {toggleSwitch == 'details' &&
                                            <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#41533d" }} className="btn btnExpandContract" onClick={(e) => toggleSwitchChange('map & details')}>Small Details&nbsp;&nbsp;
                                                <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                                {nonMapView}
                                <Card className="my-4 my-4-item">
                                    <CardHeader className="item-header card-header-click card-header-outline" onClick={toggle}>
                                        <Row>
                                            <Col sm="11">
                                                <h5 className="color-dark-teal-sub">Sites and Species of Significance&nbsp;&nbsp;&nbsp;
                                                    <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-7" onClick={(e) => e.stopPropagation()} /></h5>
                                                    <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                                        id="my-tooltip-7"
                                                        place="top"
                                                        variant="info"
                                                        render={({ content, activeAnchor }) => (
                                                            <>
                                                                <Row>
                                                                    <Col>
                                                                        <p style={{ fontWeight: "lighter" }}>
                                                                            The System will automatically decide, based on your answers below if there are any risks that need to be mitigated.
                                                                        </p>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        )}
                                                    />
                                            </Col>
                                            <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                        </Row>
                                    </CardHeader>
                                    <Collapse isOpen={isOpen}>
                                        <CardBody>
                                            <Row className="card-container">
                                                <Col sm="12">
                                                    <Row>
                                                        <Col>
                                                            <Label className="info-text" style={{ fontSize: "13px" }}>
                                                                Based on the farming activities carried out on the property, do you believe there is, or has the potential to be.
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ marginTop: "10px" }}>
                                                        <Col sm="9">
                                                            <div className="text-container" style={{}}>
                                                                <Label className="info-text" style={{ fontSize: "12px", marginLeft: "15px" }}>
                                                                    <b>• Does the property have any threatened species and/or species significant to tangata whenua or the community</b>
                                                                </Label>
                                                            </div>
                                                        </Col>
                                                        <Col sm="3">
                                                            <Input type="select" onChange={handleThreatenedSpeciesValueChange} name="ThreatenedSpecies" id="ThreatenedSpecies" value={threatenedSpecies} >
                                                                <option value={null}></option>
                                                                {yesNoList != undefined && yesNoList.map(Option =>
                                                                    <option value={Option.id}>{Option.name}</option>
                                                                )}
                                                            </Input>
                                                            {formErrors.threatenedSpecies != undefined &&
                                                                <p className="errorMessage">{formErrors.threatenedSpecies}</p>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <Row style={{marginTop:"10px"}}>
                                                        <Col sm="9">
                                                            <div className="text-container" style={{}}>
                                                                <Label className="info-text" style={{ fontSize: "12px", marginLeft: "15px" }}>
                                                                    <b>• Does the property have any recreational site(s) and/or site(s) significant to tangata whenua or the community</b>
                                                                </Label>
                                                            </div>
                                                        </Col>
                                                        <Col sm="3">
                                                            <Input type="select" onChange={handleRecreationalSitesValueChange} name="RecreationalSites" id="RecreationalSites" value={recreationalSites} >
                                                                <option value={null}></option>
                                                                {yesNoList != undefined && yesNoList.map(Option =>
                                                                    <option value={Option.id}>{Option.name}</option>
                                                                )}
                                                            </Input>
                                                            {formErrors.recreationalSites != undefined &&
                                                                <p className="errorMessage">{formErrors.recreationalSites}</p>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <br/>
                                                    <Row>
                                                        <Col sm="6">
                                                            <div className="text-container" style={{ height: "55px" }}>
                                                                <Label className="info-text" style={{ fontSize: "13px" }}>
                                                                    Name of the relevant Tangata Whenua
                                                                </Label>
                                                            </div>
                                                        </Col>
                                                        <Col sm="6">
                                                            <textarea rows="1" id="tangataWhenua" className="form-control"
                                                                name="tangataWhenua"
                                                                value={tangataWhenua}
                                                                onChange={(e) => setTangataWhenua(e.target.value)}></textarea>
                                                        </Col>
                                                    </Row>
                                                    <br />
                                                    <Row>
                                                        <Col sm="6">
                                                            <div className="text-container" style={{ height: "55px" }}>
                                                                <Label className="info-text" style={{ fontSize: "13px" }}>
                                                                    Outline the Cultural Significance of the catchment, including Te Ao Maori values where appropriate
                                                                </Label>
                                                            </div>
                                                        </Col>
                                                        <Col sm="6">
                                                            <textarea rows="3" id="culturalValuesDescription" className="form-control"
                                                                name="culturalValuesDescription"
                                                                value={culturalValuesDescription}
                                                                onChange={(e) => setCulturalValuesDescription(e.target.value)}></textarea>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                            <br />
                                            {/*<Row>*/}
                                            {/*    <Col sm="10">*/}

                                            {/*    </Col>*/}
                                            {/*    <Col sm="2">*/}
                                            {/*        {(roleName == 'SWNZ Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&*/}
                                            {/*            <>*/}
                                            {/*        {savingCatchmentContext ?*/}
                                            {/*            <Button style={{ float: "right" }} onClick={handleCatchmentContextSave}*/}
                                            {/*                color="success" className="button-save"*/}
                                            {/*                disabled*/}
                                            {/*            >*/}
                                            {/*                <Row>*/}
                                            {/*                    <Col sm="8">*/}
                                            {/*                        <span>*/}
                                            {/*                            {' '}Saving*/}
                                            {/*                        </span>*/}
                                            {/*                    </Col>*/}
                                            {/*                    <Col sm="4">*/}
                                            {/*                        <Spinner size="sm">*/}
                                            {/*                            Saving...*/}
                                            {/*                        </Spinner>*/}
                                            {/*                    </Col>*/}
                                            {/*                </Row>*/}
                                            {/*            </Button>*/}
                                            {/*            :*/}
                                            {/*            <Button className="button-save" style={{ float: "right" }} onClick={handleCatchmentContextSave} color="success" size="sm">*/}
                                            {/*                Save*/}
                                            {/*            </Button>*/}
                                            {/*            }*/}
                                            {/*            </>*/}
                                            {/*        }*/}
                                            {/*    </Col>*/}
                                            {/*</Row>*/}
                                        </CardBody>
                                    </Collapse>

                                </Card>
                            </>
                        </Col>
                    </Row>
                </div>
            }

            <Modal size="lg" isOpen={itemPopup.showItemPopup} backdrop={false} className="itemPopup">
                <Form>
                    <ModalHeader toggle={handleItemPopupClose} >Add/Edit Item</ModalHeader>
                    <ModalBody>
                        <ItemCommonTop setFormErrors={setFormErrors} itemPopupHeader={itemPopupHeader} itemPopupMaptype={itemPopupMaptype}
                            itemPopupBiodiversity={itemPopupBiodiversity} itemPopupRisk={itemPopupRisk}
                            largeEnterpriseDetails={largeEnterpriseDetails} Section={mahingaKai.Section}
                            handleItemPopupHeaderChange={handleItemPopupHeaderChange}
                            handleItemPopupBiodiversity={handleItemPopupBiodiversity}
                            handleItemPopupRisk={handleItemPopupRisk} handleLMUChange={handleLMUChange} formErrors={formErrors} ></ItemCommonTop>


                        <ItemCommonBottom setImageUploadList={setImageUploadList} imageUploadList={imageUploadList} itemPopup={itemPopup} itemPopupAchievements={itemPopupAchievements}
                            handleItemPopupAchievements={handleItemPopupAchievements} Section={mahingaKai.Section}></ItemCommonBottom>
                    </ModalBody>

                    <ItemFooter itemPopup={itemPopup} Section={mahingaKai.Section} saving={saving}
                        handleItemDeletePopup={handleItemDeletePopup}
                        handleItemSubmit={handleItemSubmit}
                        handleItemPopupClose={handleItemPopupClose}
                        handleOpenActionPopup={handleOpenActionPopup}
                        handleOpenMaintenancePlanPopup={handleOpenMaintenancePlanPopup}>
                    </ItemFooter>
                </Form>
            </Modal>

            <Modal isOpen={itemDeletePopup.showItemDeletePopup}>
                <ModalHeader toggle={handleItemDeletePopupClose} >Archive the item</ModalHeader>
                <ModalBody>
                    Do you want to archive the item ?
                </ModalBody>
                <ModalFooter>
                    {itemDeletesaving ?
                        <>
                            <Button onClick={deleteItem} color="primary" disabled>
                                <Row>
                                    <Col sm="6">
                                        <span>
                                            {' '}Saving
                                        </span>
                                    </Col>
                                    <Col sm="6">
                                        <Spinner size="sm">
                                            Saving...
                                        </Spinner>
                                    </Col>
                                </Row></Button>{' '}
                        </>
                        :
                        <>
                            <Button onClick={deleteItem} color="primary">
                                Yes
                            </Button>{' '}
                        </>
                    }
                    <Button color="danger" onClick={handleItemDeletePopupClose}>No</Button>
                </ModalFooter>
            </Modal>

            {actionPopup.showActionPopup && <Action redirectPage="/mahingakai"
                handleActionClose={handleActionClose} itemTypeId={actionPopup.itemTypeId} sectionName={mahingaKai.Section} sectionId={mahingaKai.itemTypes[0].sectionId} itemId={actionPopup.itemId} itemName={actionPopup.itemName}
                showActionPopupModal={actionPopup.showActionPopup} actionId={actionPopup.actionId} itemTypeSelect={mahingaKai.itemTypes} itemTypeDisabled={true}></Action>}

            {maintenancePlanPopup.showMaintenancePlanPopup && <MaintenancePlan handleMaintenancePlanClose={handleMaintenancePlanClose}
                showMaintenancePlanPopupModal={maintenancePlanPopup.showMaintenancePlanPopup}
                actionId={maintenancePlanPopup.actionId} itemId={maintenancePlanPopup.itemId} itemName={maintenancePlanPopup.itemName} itemTypeId={maintenancePlanPopup.itemTypeId}
                itemTypeSelect={mahingaKai.itemTypes} sectionName={mahingaKai.Section} redirectPage="/mahingakai">
            </MaintenancePlan>}
        </div>
    )
}
export default MahingaKai;